import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const Footer = () => {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-background-50 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl tracking-wide">极速高清</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              极速高清在线观看平台，无需下载，支持手机、平板、电脑多端同步。海量高清影视、综艺、纪录片随时播放。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline flex items-center gap-1.5"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4">快捷链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors no-underline">帮助中心</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-mail-line mt-0.5 text-background-400"></i>
                <span>service@jisugaoging.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-phone-line mt-0.5 text-background-400"></i>
                <span>400-888-0000</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-map-pin-line mt-0.5 text-background-400"></i>
                <span>北京市朝阳区科技园区</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-300">
                <i className="ri-time-line mt-0.5 text-background-400"></i>
                <span>周一至周日 9:00-21:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 极速高清 版权所有 | 京ICP备2024000000号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline">用户协议</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors no-underline">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;